const advogados = [
  {
    nome: 'Dr. Helio de Oliveira',
    cargo: 'Sócio',
    foto: 'https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/a80157f8ba7f54af048b433970f7ff22.jpeg',
    fotoPosition: 'center top',
    bio: [
      'Sócio do escritório, advogado formado pela UERJ em 1980 com ampla experiência em Direito de Família, Sucessões e Imobiliário.',
      'Pós-graduado em Direito Imobiliário, Família, Sucessões, Penal e Processo Penal. Ex-Delegado de Polícia Civil do Distrito Federal (aposentado).',
    ],
    email: 'helio@hosoadv.com.br',
    linkedin: 'https://linkedin.com/in/drheliodeoliveira',
    linkedinLabel: 'linkedin.com/in/drheliodeoliveira',
  },
  {
    nome: 'Dr. Bruno Santos Oliveira',
    cargo: 'Sócio',
    foto: 'https://storage.readdy-site.link/project_files/01a6a52b-4516-4062-9d79-4aff71c20140/46192f1e-0835-4f6f-96af-337028796361_Bruno-1.jpeg?v=e1e79ea15cecf231bbd9a10f7bd3cc72',
    fotoPosition: 'center top',
    bio: [
      'Sócio fundador do escritório, advogado formado pela FBCJ em 2004 com experiência em Direito Civil, Consumidor e Contratos.',
      'Ex-Assessor Jurídico e Parlamentar na Câmara Municipal do Rio de Janeiro. Atua no departamento jurídico de concessionárias de transmissão de energia elétrica: MGE, Goiás Transmissão, Transenergia Renovável e Transenergia São Paulo.',
    ],
    email: 'bruno@hosoadv.com.br',
    linkedin: 'https://linkedin.com/in/bruno-santos-oliveira-95389b86',
    linkedinLabel: 'linkedin.com/in/bruno-santos-oliveira-95389b86',
  },
  {
    nome: 'Dr. Filipe Santos Oliveira',
    cargo: 'Sócio',
    foto: 'https://storage.readdy-site.link/project_files/01a6a52b-4516-4062-9d79-4aff71c20140/c3835127-eba9-498c-8e65-ef9e11a9376b_Filipe-2.jpg?v=be5ef46740fe9f0ef3081af1f2c13868',
    fotoPosition: 'center top',
    bio: [
      'Sócio do escritório, advogado desde 2009 com atuação em contratos, direito societário e regulatório do setor de energia elétrica.',
      'Pós-graduado em Direito Corporativo (IBMEC) e Direito de Energia (PUC Minas). Graduado também em Ciências Contábeis.',
    ],
    email: 'filipe@hosoadv.com.br',
    linkedin: 'https://linkedin.com/in/filipe-santos-oliveira-36a17642',
    linkedinLabel: 'linkedin.com/in/filipe-santos-oliveira-36a17642',
  },
];

const EscritorioSection = () => {
  return (
    <section id="escritorio" className="py-16 md:py-28 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Label */}
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-10 bg-[#C8A96A]" />
          <span className="text-[#C8A96A] text-xs font-semibold tracking-[0.35em] uppercase">
            QUEM SOMOS
          </span>
        </div>

        {/* Intro text */}
        <div className="grid lg:grid-cols-2 gap-10 md:gap-16 items-start mb-16 md:mb-20">
          <div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#0F1E2E] leading-tight mb-6 md:mb-8">
              Excelência jurídica com <span className="text-[#C8A96A]">visão estratégica</span>
            </h2>
            <p className="text-[#2B2F33] text-base leading-relaxed mb-5">
              <strong>Hélio de Oliveira &amp; Santos Oliveira Advogados</strong> atua de forma estratégica nas
              esferas consultiva e contenciosa, nas áreas Civil, Imobiliária, Consumidor, Empresarial,
              Societária, Administrativa e Regulatória.
            </p>
            <p className="text-[#2B2F33] text-base leading-relaxed mb-5">
              O escritório oferece segurança jurídica e soluções eficazes, com análise criteriosa,
              prevenção de riscos e defesa técnica dos interesses dos clientes.
            </p>
            <p className="text-[#2B2F33] text-base leading-relaxed">
              Sua confiança decorre da excelência profissional, atuação ética e atendimento
              individualizado, com foco em <strong>proteção patrimonial</strong>, previsibilidade
              jurídica e decisões seguras.
            </p>
          </div>

          <div className="lg:pt-8 flex flex-col gap-5">
            {[
              { icon: 'ri-scales-3-line', text: 'Excelência profissional e atuação ética' },
              { icon: 'ri-shield-check-line', text: 'Análise criteriosa e prevenção de riscos' },
              { icon: 'ri-user-heart-line', text: 'Atendimento individualizado e personalizado' },
              { icon: 'ri-award-line', text: 'Defesa técnica e proteção patrimonial' },
            ].map((v) => (
              <div key={v.text} className="flex items-center gap-4">
                <div className="w-9 h-9 flex items-center justify-center border border-[#C8A96A]/30 flex-shrink-0">
                  <i className={`${v.icon} text-[#C8A96A] text-base`}></i>
                </div>
                <p className="text-[#2B2F33] text-sm">{v.text}</p>
              </div>
            ))}
            <div className="mt-4">
              <a
                href="#contato"
                className="inline-block px-10 py-3.5 bg-[#0F1E2E] text-[#F9FAFB] text-xs font-semibold tracking-[0.2em] uppercase hover:bg-[#1E3A5F] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Entre em contato
              </a>
            </div>
          </div>
        </div>

        {/* Team heading */}
        <div className="flex items-center gap-3 mb-10">
          <div className="h-px w-10 bg-[#C8A96A]" />
          <span className="text-[#C8A96A] text-xs font-semibold tracking-[0.35em] uppercase">
            Nossa Equipe
          </span>
        </div>

        {/* Lawyer Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {advogados.map((adv) => (
            <div key={adv.nome} className="flex flex-col">
              {/* Photo */}
              <div className="relative group overflow-hidden">
                <div className="w-full h-[320px] md:h-[400px] overflow-hidden">
                  <img
                    src={adv.foto}
                    alt={adv.nome}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{ objectPosition: adv.fotoPosition }}
                  />
                </div>
                {/* Name overlay card */}
                <div className="absolute bottom-0 left-0 right-0 bg-[#0F1E2E]/90 px-6 py-4 border-t-2 border-[#C8A96A]">
                  <p className="text-[#F9FAFB] text-base font-semibold">{adv.nome}</p>
                  <p className="text-[#C8A96A] text-xs tracking-widest uppercase mt-0.5">{adv.cargo}</p>
                </div>
              </div>

              {/* Bio */}
              <div className="bg-white border border-[#E5E7EB] border-t-0 px-6 py-6 flex flex-col flex-grow">
                <div className="flex flex-col gap-3 flex-grow">
                  {adv.bio.map((paragrafo, i) => (
                    <p key={i} className="text-[#2B2F33] text-xs leading-relaxed">
                      {paragrafo}
                    </p>
                  ))}
                </div>
                <div className="mt-auto pt-4 border-t border-[#E5E7EB] flex flex-col gap-2 mt-5">
                  <a
                    href={`mailto:${adv.email}`}
                    className="flex items-center gap-2 text-[#2B2F33]/70 text-xs hover:text-[#C8A96A] transition-colors duration-200 cursor-pointer"
                  >
                    <i className="ri-mail-line text-[#C8A96A] text-sm"></i>
                    <span>{adv.email}</span>
                  </a>
                  <a
                    href={adv.linkedin}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="flex items-center gap-2 text-[#2B2F33]/70 text-xs hover:text-[#C8A96A] transition-colors duration-200 cursor-pointer"
                  >
                    <i className="ri-linkedin-box-line text-[#C8A96A] text-sm"></i>
                    <span className="break-all">{adv.linkedinLabel}</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EscritorioSection;
